module.exports = __webpack_public_path__ + "fonts/Rubik-400-latin18.b65daad.woff2";